import * as Sentry from "@sentry/browser";
export const xhrFetch = async (url, options, successCallback, errorCallback, finallyCallback) => {
    try {
        options = {
            ...{
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            },
            ...options,
        };
        let contentType = "";
        if (typeof options.headers["Content-Type"] !== "undefined") {
            contentType = options.headers["Content-Type"];
        }
        const fetchResponse = await fetch(url, options);
        const text = await fetchResponse.text();
        let response = parseResponse(contentType, text);
        if (validateResponseStatus(fetchResponse.status)) {
            let message = response.message ? response.message : "Something its wrong.";
            handleError(message, errorCallback(response));
        } else {
            handleSuccess(response, successCallback);
        }
    } catch (exception) {
        handleError(exception, errorCallback);
    } finally {
        if (typeof finallyCallback === "function") {
            finallyCallback();
        }
    }
};

const handleSuccess = (response, callback) => {
    if (typeof callback === "function") {
        callback(response);
    }
};

const handleError = (exception, callback) => {
    console.error(exception);
    Sentry.captureException(exception);
    if (typeof callback === "function") {
        callback(exception);
    }
};

export const buildFormDataFromJson = (json) => {
    return JSON.stringify(json);
};

const prepareFormDataToBody = (formData) => {
    const data = new URLSearchParams();
    for (const pair of formData) {
        data.append(pair[0], pair[1]);
    }

    return data;
};

const parseResponse = (contentType, data) => {
    let response;
    switch (contentType) {
        case "application/json":
            response = data ? JSON.parse(data) : {};
            break;
        case "text/html":
            response = data;
            break;
        default:
            response = {};
            break;
    }

    return response;
};

const validateResponseStatus = (status) => {
    return !(status >= 200 && status < 300);
};
